// src/Chatmodules/getSearchTerm.js
import ingredientsList from './ingredientsList.js';
import dietLabelsList from './dietLabelsList.js';
import cuisineTypesList from './cuisineTypesList.js';
import healthLabelsList from './healthLabelsList.js';
import nlp from 'compromise';

const getSearchTermAndTitle = (userInput) => {
    const doc = nlp(userInput);

    let identifiedIngredients = [];
    let identifiedDiets = [];
    let identifiedCuisines = [];
    let identifiedHealthLabels = [];

    // Identificación de ingredientes, dietas, cocinas y etiquetas de salud
    ingredientsList.forEach(ingredient => {
        if (doc.match(ingredient.toLowerCase()).found) {
            identifiedIngredients.push(ingredient);
       }
   });

    dietLabelsList.forEach(diet => {
        if (doc.match(diet.label.toLowerCase()).found) {
            identifiedDiets.push(diet.label);
       }
   });

    cuisineTypesList.forEach(cuisine => {
        if (doc.match(cuisine.label.toLowerCase()).found) {
            identifiedCuisines.push(cuisine.label);
       }
   });

    healthLabelsList.forEach(health => {
        if (doc.match(health.label.toLowerCase()).found) {
            identifiedHealthLabels.push(health.label);
       }
   });

    // Construir un título detallado usando las listas identificadas
    let title = "Nuevo Chat";

    if (identifiedDiets.length > 0) {
        title = `Recetas  ${identifiedDiets[0]}`;
   } else if (identifiedHealthLabels.length > 0) {
        title = `Recetas ${identifiedHealthLabels[0]}`;
   } else if (identifiedCuisines.length > 0) {
        title = `Recetas de ${identifiedCuisines[0]}`;
   } else if (identifiedIngredients.length > 0) {
        title = `Recetas con ${identifiedIngredients[0]}`;
   }

    return {
        searchTerm: identifiedIngredients[0] || userInput,
        title,
        identifiedDiets,
        identifiedCuisines,
        identifiedHealthLabels
   };
};

export default getSearchTermAndTitle;